module.exports = __webpack_public_path__ + "static/media/hkdirLogo.341673c8.svg";